import { TrendingUp, TrendingDown } from 'lucide-react'
import { pct } from './utils'

export function ChangeBadge({ current, previous }: { current: number; previous: number }) {
  const change = pct(current, previous)
  if (change === null || change === 0) return null
  const isPositive = change > 0
  return (
    <span
      className={`inline-flex items-center gap-0.5 text-xs font-medium px-1.5 py-0.5 rounded-sm ${
        isPositive ? 'bg-primary/10 text-primary' : 'bg-destructive/10 text-destructive'
      }`}
    >
      {isPositive ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}
      {isPositive ? '+' : ''}
      {change}%
    </span>
  )
}
